import { MDBNotification} from 'mdbreact'
import React from 'react'
import { Notification } from '../../interfaces/Notification_interface'

const ShowNotification: React.FC<Notification> = (props: Notification) => {
    return (
        <>
            <MDBNotification
                    icon={props.icon}
                    iconClassName={props.iconClassName}
                    bodyClassName={props.bodyClassName}
                    show
                    fade
                    autohide={props.autohide}
                    title={props.title}
                    message={props.message}
                    text={props.text}
                    style={{
                        position: "fixed",
                        top: "10px",
                        right: "10px",
                        zIndex: 9999
                    }}
                />
        </>
    )
}
export default ShowNotification
